var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggleSwitch',{attrs:{"title":"Anzahl verfügbarer Termine anzeigen","value":_vm.data,"callback":_vm.setValue}})}
var staticRenderFns = []

export { render, staticRenderFns }